export default "__VITE_ASSET__6cc69893__"